<template>
  <details v-if="items.length" class="whatsapp-notice">
    <summary class="whatsapp-notice__summary">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
      <span class="whatsapp-notice__title">{{ title }}</span>
      <span class="whatsapp-notice__count">{{ items.length }}</span>
      <span class="whatsapp-notice__toggle">
        <span class="when-closed">Ver detalhes</span>
        <span class="when-open">Ocultar detalhes</span>
        <i class="fas fa-chevron-down" aria-hidden="true"></i>
      </span>
    </summary>
    <div class="whatsapp-notice__body">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="whatsapp-notice__item"
      >
        <div class="whatsapp-notice__account"><slot :item="item" /></div>
        <p class="whatsapp-notice__message">{{ item.error.message }}</p>
        <ul v-if="item.error.diagnostic && item.error.diagnostic.messages">
          <li v-for="(message, i) in item.error.diagnostic.messages" :key="i">
            {{ message }}
          </li>
        </ul>
      </div>
    </div>
  </details>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
    title: { type: String, required: true }
  }
};
</script>

<style scoped>
.whatsapp-notice {
  margin: 12px 0 16px;
  border: 1px solid #e8e5df;
  border-radius: 8px;
  background: #fff;
  color: #5f636b;
  font-size: 13px;
}
.whatsapp-notice__summary {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  list-style: none;
}
.whatsapp-notice__summary::-webkit-details-marker {
  display: none;
}
.whatsapp-notice__summary:focus-visible {
  outline: 2px solid #82709e;
  outline-offset: 2px;
  border-radius: 8px;
}
.whatsapp-notice__summary > i {
  color: #b88736;
  font-size: 14px;
}
.whatsapp-notice__title {
  font-weight: 500;
}
.whatsapp-notice__count {
  padding: 1px 7px;
  border-radius: 10px;
  background: #f5f1e9;
  color: #916a2c;
  font-size: 11px;
}
.whatsapp-notice__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  white-space: nowrap;
  font-size: 12px;
}
.whatsapp-notice__toggle i {
  font-size: 9px;
}
.when-open {
  display: none;
}
.whatsapp-notice[open] .when-open {
  display: inline;
}
.whatsapp-notice[open] .when-closed {
  display: none;
}
.whatsapp-notice[open] .whatsapp-notice__toggle i {
  transform: rotate(180deg);
}
.whatsapp-notice__body {
  border-top: 1px solid #efefef;
  padding: 0 14px;
  max-height: 320px;
  overflow-y: auto;
  overflow-wrap: anywhere;
}
.whatsapp-notice__item {
  padding: 12px 0;
}
.whatsapp-notice__item + .whatsapp-notice__item {
  border-top: 1px solid #efefef;
}
.whatsapp-notice__account {
  font-weight: 600;
  color: #42464d;
  margin-bottom: 5px;
}
.whatsapp-notice__message {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}
.whatsapp-notice__item ul {
  padding-left: 18px;
  margin: 8px 0 0;
  font-size: 12px;
}
@media (max-width: 576px) {
  .whatsapp-notice__summary {
    flex-wrap: wrap;
  }
  .whatsapp-notice__toggle {
    width: 100%;
    margin-left: 24px;
  }
}
</style>
